module.exports = __webpack_public_path__ + "img/fig03.fdac4a40.jpg";